import { MAX_INVITED_MEMBERS } from "@components/teams/teams-constants";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";

/** The label of the action, so that every place offering it uses the same words */
export const ADD_TO_TEAM_TITLE = `Add to ${TEAM_DISPLAY_NAME}`;

/** Why the action is disabled when more members are selected than one request can take */
export const ADD_TO_TEAM_LIMIT_MESSAGE = `Select up to ${MAX_INVITED_MEMBERS} members to add them to a ${TEAM_DISPLAY_NAME}.`;